import { render } from "./ActionsAttachments.vue?vue&type=template&id=1a40c27a"
import script from "./ActionsAttachments.vue?vue&type=script&lang=js"
export * from "./ActionsAttachments.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__